import React from "react";
import { Tooltip } from "../Tooltip";
import RequiredIcon from "./RequiredIcon.styles";
import Root from "./Root.styles";
import Text, { TextProps } from "./Text.styles";

export interface LabelComponentProps extends TextProps {
  children?: React.ReactNode;
  className?: string;
  htmlFor?: string;
  required?: boolean;
  tooltipText?: string;
}

export const Label = ({
  htmlFor,
  disabled = false,
  isValid = true,
  required,
  className,
  children,
  tooltipText = "Required field"
}: LabelComponentProps) => {
  return (
    <Root htmlFor={htmlFor} className={className}>
      <Text disabled={disabled} isValid={isValid} as="span">
        {children}
      </Text>
      {required && (
        <Tooltip side="top" tooltip={tooltipText}>
          <RequiredIcon isValid={isValid} />
        </Tooltip>
      )}
    </Root>
  );
};
